import { Box, Container, Typography } from '@mui/material';
import { useThemeMode } from '../context/ThemeContext';
import { usePricing } from '../hooks/usePricing';

export default function TermsOfSale() {
  const { colors } = useThemeMode();
  const { unitPrice, proPrice, proDeclarations } = usePricing();

  return (
    <Box sx={{ bgcolor: colors.bgDefault, minHeight: '100vh', py: 8 }}>
      <Container maxWidth="md">
        <Typography variant="h3" sx={{ color: colors.textPrimary, fontWeight: 700, mb: 3 }}>
          Conditions générales de vente
        </Typography>

        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 3, lineHeight: 1.8 }}>
          Dernière mise à jour : juin 2026
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          1. Offres et tarifs
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Publy Music propose deux formules : un achat à l'unité ({unitPrice} par déclaration)
          et un abonnement mensuel ({proPrice}/mois, jusqu'à {proDeclarations} déclarations). Les tarifs
          sont indiqués TTC. Publy Music se réserve le droit de modifier ses tarifs,
          les modifications prenant effet au prochain renouvellement.
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          2. Paiement
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Les paiements sont effectués par carte bancaire via la plateforme sécurisée Stripe.
          Aucune information de paiement n'est stockée sur nos serveurs.
          L'abonnement est renouvelé automatiquement chaque mois sauf résiliation.
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          3. Droit de rétractation
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Conformément à l'article L.221-28 du Code de la consommation, le droit de rétractation
          ne s'applique pas aux contenus numériques fournis sur un support immatériel dont
          l'exécution a commencé avec l'accord du consommateur. L'utilisation du service
          (génération d'un document) vaut début d'exécution.
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          4. Résiliation de l'abonnement
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Vous pouvez résilier votre abonnement à tout moment depuis la page Paramètres.
          La résiliation prend effet à la fin de la période en cours. Aucun remboursement
          prorata n'est effectué.
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          5. Réclamations
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Pour toute réclamation, contactez-nous à contact@publymusic.fr. Nous nous engageons
          à répondre dans un délai de 48 heures ouvrées.
        </Typography>
      </Container>
    </Box>
  );
}
